document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-order-detail-tabs]');
  if (!root) {
    return;
  }

  const tabs = root.querySelectorAll<HTMLButtonElement>('[data-order-detail-tab]');
  const panels = document.querySelectorAll<HTMLElement>('[data-order-detail-panel]');
  const title = root.querySelector<HTMLElement>('[data-order-detail-title]');

  const setTab = (name: string, updateHistory = false) => {
    tabs.forEach((tab) => {
      const active = tab.dataset.orderDetailTab === name;
      tab.classList.toggle('--active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    panels.forEach((panel) => {
      panel.hidden = panel.dataset.orderDetailPanel !== name;
    });

    if (title) {
      const key = name === 'invoices' ? 'titleInvoices' : 'titleOrder';
      title.textContent = title.dataset[key] ?? title.textContent;
    }

    if (!updateHistory) {
      return;
    }

    const url = new URL(window.location.href);
    if (name === 'invoices') {
      url.searchParams.set('tab', 'invoices');
    } else {
      url.searchParams.delete('tab');
    }
    history.pushState({ tab: name }, '', url);
  };

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const name = tab.dataset.orderDetailTab ?? 'order';
      if (tab.classList.contains('--active')) {
        return;
      }
      setTab(name, true);
    });
  });

  window.addEventListener('popstate', () => {
    const name = new URLSearchParams(window.location.search).get('tab') === 'invoices' ? 'invoices' : 'order';
    setTab(name);
  });

  const initialTab = new URLSearchParams(window.location.search).get('tab') === 'invoices' ? 'invoices' : 'order';
  setTab(initialTab);
});
